<template>
  <div class="container-fluid">
    <b-modal
      hide-footer
      hide-header
      id="delete_modal"
      color="warning"
      :show.sync="warning_modal"
    >
      {{ $trans.main.delete_warning }}
        <b-button variant="outline-secondary" block class="btn mt-3" @click="$bvModal.hide('delete_modal')">
          {{ $trans.main.button_cancel }}
        </b-button>
        <b-button
          variant="outline-danger"
          block class="btn mt-3"
          @click="deleteProtocol(deleted_protocol); $bvModal.hide('delete_modal')"
        >
          {{ $trans.main.button_delete }}
        </b-button>
    </b-modal>
    <div class="row">
      <div class="col">
        <table class="table ">
          <thead>
          <tr>
            <th scope="col">{{ $trans.protocol.date }}</th>
            <th scope="col">{{ $trans.protocol.object }}</th>
            <th scope="col">{{ $trans.protocol.street }}</th>
            <th scope="col">{{ $trans.protocol.tenant }}</th>
            <th scope="col">{{ $trans.protocol.status }}</th>
            <th scope="col">
              <button class="btn btn-success" @click="synchronize()">{{ $trans.main.button_synchronize }}</button>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="protocol in protocols">
            <td @click="editProtocol(protocol)">{{ moment(new Date(protocol.date)).format('DD.MM.YYYY') }}</td>
            <td @click="editProtocol(protocol)">{{ protocol.object }}</td>
            <td @click="editProtocol(protocol)">{{ protocol.street }}</td>
            <td @click="editProtocol(protocol)">{{ protocol.tenant }}</td>
            <td @click="editProtocol(protocol)">{{ protocol.draft ? $trans.protocol.draft : $trans.protocol.not_synchronized }}</td>
            <td>
              <button class="btn btn-danger" @click="deleteProtocolWarning(protocol)">{{ $trans.main.button_delete }}</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import moment from 'moment'

export default {
  name: 'LocalProtocols',
  props: {
    local: Boolean
  },
  data () {
    return {
      protocols: [],
      deleted_protocol: {},
      warning_modal: false,
      moment: moment
    }
  },
  created () {
    this.getProtocols({local: true}).then(result => {
      this.protocols = result
    }, error => {
      console.log(error)
    })
  },
  methods: {
    ...mapActions(['getProtocols', 'deleteProtocolFromIdb', 'saveProtocol']),
    async deleteProtocol (protocol) {
      await this.deleteProtocolFromIdb({protocol})
      this.getProtocols({local: true}).then(result => {
        this.protocols = result
      }, error => {
        console.log(error)
      })
    },
    deleteProtocolWarning (protocol) {
      this.deleted_protocol = protocol
      this.$bvModal.show('delete_modal')
      this.warning_modal = true
    },
    editProtocol (protocol) {
      this.$router.push({name: 'LocalProtocolEdit', params: {id: protocol.id}})
    },
    async synchronize () {
      for (let protocol of this.protocols) {
        if (!protocol.draft) {
          await this.saveProtocol({protocol: protocol, local: false}).then(result => {
          }, error => {
            console.log(error)
          })
        }
      }
      this.getProtocols({local: true}).then(result => {
        this.protocols = result
      }, error => {
        console.log(error)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/local/Protocols.vue